import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Histórico da Rota" />;
}

export default GridHeader;